export default __webpack_public_path__ + "static/media/Pistol_7.978f744f.png";